import AnalyticsBase from './AnalyticsBase';

class ErrorEvent extends AnalyticsBase {
  id: string;

  message?: string;
}

export default ErrorEvent;
